<template>
    <div class="col-xs-12 form-group" :class="{ 'has-error': this.validation && this.validation.$error }">
        <!--<label class='control-label' v-if='label' :for='name'>{{ label }}</label>-->
        <div class="input-group username-input has-feedback">
            <float-label
                :label="required ? label+'*': label"
                :for="name"
                :fixed="type === 'date'"
            >
                <input
                  v-if="type === 'date'"
                  autocomplete='off'
                  type='date'
                  ref='input'
                  class='form-control'
                  pattern="\d{4}-\d{2}-\d{2}"
                  :id='name'
                  :name='name'
                  :placeholder="required ? label+'*': label"
                  :value='value'
                  :min="minDate"
                  :max="maxDate"
                  @input='updateValue($event.target.value)'
                  @blur='blur'
                />
                <input
                  v-else
                  autocomplete='off'
                  type='text'
                  :id='name'
                  :name='name'
                  ref='input'
                  class='form-control'
                  :placeholder="required ? label+'*': label"
                  :value='value'
                  @input='updateValue($event.target.value)'
                  @blur='blur'
                />
            </float-label>
            <span class="input-group-addon">
                  <i class="glyphicon " :class="displayIcons(name)"></i>
            </span>
        </div>
        <div class='help-block small' role='alert' v-if='validation && validation.$error'>
            <span v-if='requiredError'>The field is required</span>
            <span v-else-if='!validation.maxLength && validation.$params.maxLength'>
              Maximum length is {{validation.$params.maxLength.max}}
            </span>
            <span v-else-if='!validation.minLength && validation.$params.minLength'>
              Minimum length is {{validation.$params.minLength.min}}
            </span>
            <span v-else-if='validation.dateFormat === false'>The date field must be in a valid format</span>
            <span v-else-if="!validation.dateBetween && validation.$params.dateBetween">
                Date must be between {{ validation.$params.dateBetween.min }} and
              {{ validation.$params.dateBetween.max }}
            </span>
          <span v-else-if='validation.$invalid'>The {{label.toLowerCase()}} field is invalid.</span>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line
import FloatLabel from 'vue-float-label/components/FloatLabel.vue';
export default {
  name: 'input-text',
  components: {
    FloatLabel,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default() {
        return undefined;
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    minDate: {
      type: String,
      validator: value => (/\d{4}-\d{2}-\d{2}/).test(value),
      required: false,
    },
    maxDate: {
      type: String,
      validator: value => (/\d{4}-\d{2}-\d{2}/).test(value),
      required: false,
    },
  },
  computed: {
    required() {
      return (
        !this.loading &&
        this.validation &&
        (this.validation.required !== undefined ||
          this.validation.requiredIf !== undefined)
      );
    },
    requiredError() {
      return (
        this.validation &&
        this.validation.$error &&
        ((this.validation.required !== undefined && !this.validation.required) ||
        (this.validation.requiredIf !== undefined && !this.validation.requiredIf))
      );
    },
  },
  methods: {
    blur() {
      // Only validate the input on blur
      if (this.validation) {
        this.validation.$touch();
      }
    },
    updateValue(value) {
      this.$emit('input', value);
    },
    displayIcons(field) {
      switch (field) {
        case 'firstName':
          return 'glyphicon-pencil';
        case 'name':
          return 'glyphicon-pencil';
        case 'surname':
          return 'glyphicon-pencil';
        case 'lastName':
          return 'glyphicon-pencil';
        case 'username':
          return 'glyphicon-user';
        case 'emailAddress':
          return 'glyphicon-envelope';
        case 'cellularNumber':
          return 'glyphicon-phone';
        case 'cellularAddress':
          return 'glyphicon-phone';
        case 'identityNumber':
          return 'glyphicon-info-sign';
        case 'passportNumber':
          return 'glyphicon-info-sign';
        case 'practicePhone':
          return 'glyphicon-phone-alt';
        default: return 'glyphicon-asterisk';
      }
    },
  },
  watch: {
    label(newLabel) {
      this.label = newLabel;
    },
  },
  mounted() {
    if (this.validation && this.required) {
      this.$refs.input.required = true;
    }
  },
};
</script>
<style scoped>
.username-input {
  width: 99.4%;
  padding: 0 0 0 6.5px;
}

input::-ms-clear,
input::-ms-reveal {
  display: none;
}
</style>



// WEBPACK FOOTER //
// InputText.vue?5769b044